import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NigeriaDailyOutpatientRegisterQueryVariables = Types.Exact<{
  input: Types.NigeriaDailyOutpatientRegisterInput;
}>;


export type NigeriaDailyOutpatientRegisterQuery = { readonly __typename?: 'Query', readonly nigeriaDailyOutpatientRegister?: { readonly __typename?: 'PaginatedNigeriaDailyOutpatientRegister', readonly limit?: number | null, readonly offset?: number | null, readonly total?: number | null, readonly records?: ReadonlyArray<{ readonly __typename?: 'NigeriaDailyOutpatientRegisterRecord', readonly id: string, readonly date: string, readonly isPregnant?: boolean | null, readonly attendanceType?: Types.NigeriaDailyOutpatientAttendance | null, readonly weight?: number | null, readonly height?: number | null, readonly BMI?: number | null, readonly presentingComplaint?: string | null, readonly investigationsCompleted?: ReadonlyArray<string | null> | null, readonly diagnosis?: ReadonlyArray<string | null> | null, readonly drugsGiven?: ReadonlyArray<string | null> | null, readonly outcomeOfVisit?: Types.NigeriaDailyOutpatientOutcome | null, readonly malariaDiagnosis?: Types.NigeriaDailyOutpatientMalariaDiagnosis | null, readonly actGiven?: boolean | null, readonly otherAntimalarialGiven?: boolean | null, readonly severeMalaria?: boolean | null, readonly preReferralTreatment?: Types.NigeriaDailyOutpatientPreReferralTreatment | null, readonly tbClinicallyScreened?: boolean | null, readonly tbClinicalScreeningForm?: boolean | null, readonly tbReferred?: boolean | null, readonly hepatitisB?: Types.NigeriaDailyOutpatientHepatitisResult | null, readonly hepatitisC?: Types.NigeriaDailyOutpatientHepatitisResult | null, readonly gbvCaseSeen?: ReadonlyArray<Types.NigeriaDailyOutpatientGbvCase | null> | null, readonly postGBVCareReceived?: boolean | null, readonly gbvCaseReferred?: boolean | null, readonly patient: { readonly __typename?: 'Patient', readonly uuid: string, readonly cardId?: string | null, readonly person: { readonly __typename?: 'Person', readonly dob: string, readonly gender: Types.Gender, readonly name: { readonly __typename?: 'Name', readonly fullname?: string | null } }, readonly passport?: { readonly __typename?: 'Passport', readonly uid: string } | null } } | null> | null } | null };


export const NigeriaDailyOutpatientRegisterDocument = gql`
    query NigeriaDailyOutpatientRegister($input: NigeriaDailyOutpatientRegisterInput!) {
  nigeriaDailyOutpatientRegister(input: $input) {
    limit
    offset
    total
    records {
      id
      date
      patient {
        uuid
        person {
          name {
            fullname
          }
          dob
          gender
        }
        cardId
        passport {
          uid
        }
      }
      isPregnant
      attendanceType
      weight
      height
      BMI
      presentingComplaint
      investigationsCompleted
      diagnosis
      drugsGiven
      outcomeOfVisit
      malariaDiagnosis
      actGiven
      otherAntimalarialGiven
      severeMalaria
      preReferralTreatment
      tbClinicallyScreened
      tbClinicalScreeningForm
      tbReferred
      hepatitisB
      hepatitisC
      gbvCaseSeen
      postGBVCareReceived
      gbvCaseReferred
    }
  }
}
    `;

/**
 * __useNigeriaDailyOutpatientRegisterQuery__
 *
 * To run a query within a React component, call `useNigeriaDailyOutpatientRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useNigeriaDailyOutpatientRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNigeriaDailyOutpatientRegisterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNigeriaDailyOutpatientRegisterQuery(baseOptions: Apollo.QueryHookOptions<NigeriaDailyOutpatientRegisterQuery, NigeriaDailyOutpatientRegisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NigeriaDailyOutpatientRegisterQuery, NigeriaDailyOutpatientRegisterQueryVariables>(NigeriaDailyOutpatientRegisterDocument, options);
      }
export function useNigeriaDailyOutpatientRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NigeriaDailyOutpatientRegisterQuery, NigeriaDailyOutpatientRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NigeriaDailyOutpatientRegisterQuery, NigeriaDailyOutpatientRegisterQueryVariables>(NigeriaDailyOutpatientRegisterDocument, options);
        }
export type NigeriaDailyOutpatientRegisterQueryHookResult = ReturnType<typeof useNigeriaDailyOutpatientRegisterQuery>;
export type NigeriaDailyOutpatientRegisterLazyQueryHookResult = ReturnType<typeof useNigeriaDailyOutpatientRegisterLazyQuery>;
export type NigeriaDailyOutpatientRegisterQueryResult = Apollo.QueryResult<NigeriaDailyOutpatientRegisterQuery, NigeriaDailyOutpatientRegisterQueryVariables>;